import Store from '@core/Store';
import AuthStore from '../../utils/AuthStore';
import { context } from '@client/context';
import { Token } from '@client/utils/SmukApi';

type RegistrationState = {
	ready: boolean;
	token: Token | undefined;
	registered: boolean | undefined;
};

const DefaultState = {
	ready: false,
	token: undefined,
	registered: undefined,
};

class RegistrationStoreClass extends Store<RegistrationState> {
	constructor() {
		super(DefaultState);

		// AuthStore.userSignedIn.on(this.onUserSignedIn);
		AuthStore.userSignedOut.on(this.onUserSignedOut);
	}

	// private onUserSignedIn = (_: IAzureAuthData) => {
	// 	this.load();
	// };

	private onUserSignedOut = () => {
		this.set(DefaultState);
	};

	public async load() {
		const res = await context.smukAPI.getToken().catch(err => {
			console.warn(err);
			return undefined;
		});

		this.set({
			ready: true,
			token: res,
			registered: !!res,
		});
	}

	public async setToken({ control, serial }: { control: string; serial: string }) {
		const res = await context.smukAPI.registerToken({
			control,
			serial,
		});

		this.set({
			token: res,
			registered: true,
		});
	}

	public async removeToken() {
		return await context.smukAPI.removeToken().then(() => {
			this.set({
				token: undefined,
				registered: false,
			});
		});
	}
}

const RegistrationStore = new RegistrationStoreClass();

export default RegistrationStore;
